import { createReducer, on } from "@ngrx/store";
import { todayDataModel } from "@sports-models/index";
import * as SportsbookActions from "../../../stores/sportsbook/sportsbook.actions";

export const initialState: todayDataModel = {
  fiveDays: [],
  selectedDay: null,
  selectedSport: { CategoryId: "soccer", IsRelevant: true, CategoryName: "Fútbol", numGames: 0, name: "Fútbol" },
  sportsFilters: [
    { CategoryId: "soccer", IsRelevant: true, CategoryName: "Fútbol", numGames: 0, name: "Fútbol" },
    { CategoryId: "tennis", IsRelevant: true, CategoryName: "Tenis", numGames: 0, name: "Tenis" },
    { CategoryId: "basketball", IsRelevant: true, CategoryName: "Baloncesto", numGames: 0, name: "Baloncesto" },
  ],
  sportsEvents: [],
  selectedEventsNodeIds: [],
};

export const SportsbookTodayReducer = createReducer(
  initialState,
  // TodayPage
  on(SportsbookActions.fetchTodayLeagueEvents, (state, { type, ...payload }) => {
    return {
      ...state,
      ...payload,
    };
  }),
  on(SportsbookActions.setToday, (state, todayData) => ({
    ...state,
    ...todayData,
  })),
  on(SportsbookActions.clearToday, (state) => ({
    ...state,
    ...initialState,
  })),
  on(SportsbookActions.setTodaySelectedSport, (state) => {
    return {
      ...state,
      sportsEvents: [],
    };
  }),
);
